export default {
      id: "car-back-usage",
      viewBox: "0 0 50 35",
      url: __webpack_public_path__ + "img/icons.svg#car-back",
      toString: function () {
        return this.url;
      }
    }